import axios from "axios";
import qs from "qs";
const token = localStorage.getItem("access_token"); // Replace with your actual Bearer Token

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json", // Assuming you're sending JSON data
};
const Building = {
  getAll: () =>
    axios.post(
      `/buildings/getBuildingsList`,
      {
        sortproperty: "name",
        sortorder: -1,
        offset: 0,
        limit: 50,
        query: {
          critarion: { active: true },
          addedby: "_id email name",
          lastModifiedBy: "_id email name",
        },
      },
      { headers: headers }
    ),

  getOne: (ID) =>
    axios.post(`/buildings/findBuildingById`, {
      critarion: { _id: `${ID}`, active: "true" },
    }),

  getAccounts: () => axios.get("/transfer/accounts"),

  add: (data) => axios.post("/buildings/createBuilding", data),

  update: (data, ID) =>
    axios.post(`buildings/updateBuilding`, { buildingid: ID, ...data }),

  getByMember: (ID, pagination, date) =>
    axios.get(
      `/transfer/member/${ID}?${qs.stringify(pagination)}&${qs.stringify(date)}`
    ),

  remove: (data) => axios.post("/buildings/removeBuilding", data),
};

export default Building;
